import { render, staticRenderFns } from "./Screen4.vue?vue&type=template&id=80d22c9e&scoped=true&lang=html&"
import script from "./Screen4.vue?vue&type=script&lang=js&"
export * from "./Screen4.vue?vue&type=script&lang=js&"
import style0 from "./Screen4.vue?vue&type=style&index=0&id=80d22c9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d22c9e",
  null
  
)

export default component.exports